import styles from './GenerationInfoButton.module.css';

type Props = {
  onClick: () => void;
  className?: string;
};

export function GenerationInfoButton({ onClick, className }: Props) {
  return (
    <button
      type="button"
      className={className ? `${styles.button} ${className}` : styles.button}
      onClick={onClick}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
      </svg>
      AI生成情報
    </button>
  );
}
